import { AnimatePresence, motion } from "framer-motion";
import { forwardRef, useImperativeHandle, useState } from "react";
import DialogBackdrop from "./Backdrop";
import CloseButtonDialog from "./CloseButton";
import { createPortal } from "react-dom";

const Dialog = forwardRef((props, ref) => {
  const { children, hiddenCloseButton = false, className } = props;

  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  }));

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <>
          <DialogBackdrop />
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-6 "
            initial={{ y: -600 }}
            animate={{ y: 0 }}
            exit={{ y: -1600 }}
          >
            <motion.div
              className={`${className} bg-white rounded-2xl shadow-2xl max-w-lg w-full p-4 xs:p-6 relative max-h-[80vh] overflow-y-auto scrollbar-hide`}
            >
              {!hiddenCloseButton && (
                <CloseButtonDialog setIsOpen={setIsOpen} />
              )}

              {children}
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
});

Dialog.displayName = "Dialog";

export default Dialog;
